




exports.createReceiveMessageSystem = ({
    addItemSystem,
    openItemSystem,
    authSystem,
    selectStateSystem,
    pingSystem
})=>{
	const messageMap = {
		'search.requestPing': pingSystem.handleRequestPing,
		'search.requestAuthToken': authSystem.handleRequestAuthToken,
		'search.openItem': openItemSystem.handleRequestOpenItem,
		'search.addMoodToSoundset': addItemSystem.handleRequestAddMood,
		'search.addElementToSoundset': addItemSystem.handleRequestAddElement,
		'search.addSampleToPlaylist': addItemSystem.handleRequestAddSample,
		// REVIEW: `requestState` event is not dispatched anywhere
		'search.requestState': selectStateSystem.handleRequestState,
		'search.requestInitialUrlParams':
			selectStateSystem.handleRequestInitialUrlParams,
		'search.setUrlParam': selectStateSystem.handleSetUrlParam,
	}

	for (const messageName in messageMap) {
		document.addEventListener(`syrinscape.${messageName}`, (e) => {
			const { params, token } = e.detail
			if (token !== context.API_TOKEN) {
				return
			}
			messageMap[messageName](params)
		})
	}
}



// WEBPACK FOOTER //
// ./djangosite/master/frontend/src/search-panel/receiveMessageSystem.js